import { ArrowBack } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserSelectors } from '../../reducers/user';
import AppBarComp from '../AppBarComp';
import User from './User';

interface ProfileProps {

}

type Props = ProfileProps;


const Profile: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const navigate = useNavigate();

    return user ? <Box height={{ xs: "initial", md: "100vh" }} minHeight="100vh" display="flex" flexDirection="column" sx={{ backgroundColor: "#f5f5f5" }}>
        <AppBarComp />
        <Container maxWidth="md" sx={{ display: "flex", flexDirection: "column", flex: 1, pt: 2, pb: { xs: "60px", md: "40px" } }}>
            <Box >
                <Button onClick={() => { navigate("/user") }} sx={{ mb: 1.5 }}>
                    <Box display="flex" alignItems="center" color="GrayText" >
                        <ArrowBack fontSize='small' sx={{ mr: 1 }} color="inherit" />
                        <Typography fontSize="0.85rem" >Dashboard</Typography>
                    </Box>
                </Button>
                <Box sx={{ background: "white" }}>
                    <User />
                </Box>
            </Box>
        </Container>
    </Box> : null;
}


export default Profile;

